const FLOATING_MENU_FACE_TYPES = [
  'front',
  'back',
  'inside',
  'inside-left',
  'inside-right',
  'inside-top',
  'inside-bottom',
] as const;

export type FloatingMenuFaceType = (typeof FLOATING_MENU_FACE_TYPES)[number];

type GetShouldShowFloatingMenuProps = {
  isFloatingMenuEnabled: boolean;
  isCropping: boolean;
  isSignAndSend: boolean;
  isOneToMany: boolean;
  currentFaceType?: FloatingMenuFaceType;
};

export const getFloatingMenuFaceType = (faceType?: string): FloatingMenuFaceType | undefined => {
  return FLOATING_MENU_FACE_TYPES.find((type) => type === faceType);
};

const isInsideSurface = (faceType?: FloatingMenuFaceType): boolean => {
  return (
    faceType === 'inside' ||
    faceType === 'inside-left' ||
    faceType === 'inside-right' ||
    faceType === 'inside-top' ||
    faceType === 'inside-bottom'
  );
};

export const getShouldShowFloatingMenu = ({
  isFloatingMenuEnabled,
  isCropping,
  isSignAndSend,
  isOneToMany,
  currentFaceType,
}: GetShouldShowFloatingMenuProps): boolean => {
  const isOneToManyBackSurface = isOneToMany && currentFaceType === 'back';

  return (
    isFloatingMenuEnabled &&
    !isCropping &&
    (isSignAndSend || isInsideSurface(currentFaceType) || isOneToManyBackSurface)
  );
};
